import { useEffect } from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { useLanguage } from "./i18n/LanguageContext";
import { langFromPath, withLang } from "./lib/router";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Reformer from "./pages/Reformer";
import ReformerDetail from "./pages/ReformerDetail";
import Equipment from "./pages/Equipment";
import Studios from "./pages/Studios";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Inquiry from "./pages/Inquiry";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import { Intro } from "./components/Intro";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

const LangSync = () => {
  const { pathname } = useLocation();
  const { lang, setLang } = useLanguage();
  useEffect(() => {
    const urlLang = langFromPath(pathname);
    if (urlLang !== lang) setLang(urlLang);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

const PAGES = [
  ["/", <Home />],
  ["/reformer", <Reformer />],
  ["/reformer/:slug", <ReformerDetail />],
  ["/equipment", <Equipment />],
  ["/fuer-studios", <Studios />],
  ["/studios", <Navigate to="/fuer-studios" replace />],
  ["/ueber-uns", <About />],
  ["/kontakt", <Contact />],
  ["/anfrage", <Inquiry />],
  ["/danke", <ThankYou />],
  ["/impressum", <Legal slug="impressum" />],
  ["/datenschutz", <Legal slug="datenschutz" />],
  ["/agb", <Legal slug="agb" />],
  ["/widerruf", <Legal slug="widerruf" />],
];

const Shell = () => {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin");
  return (
    <>
      <ScrollManager />
      <LangSync />
      {!bare && <Intro />}
      {!bare && <Navbar />}
      <main>
        <Routes>
          {["de", "en", "fr", "es"].flatMap((lang) =>
            PAGES.map(([path, el]) => (
              <Route key={`${lang}${path}`} path={withLang(path, lang)} element={path === "/studios" ? <Navigate to={withLang("/fuer-studios", lang)} replace /> : el} />
            ))
          )}
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to={withLang("/", langFromPath(pathname))} replace />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1C1C1A",
            color: "#FAF8F5",
            border: "1px solid rgba(250,248,245,0.12)",
            borderRadius: 0,
          },
        }}
      />
    </>
  );
};

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []); // mount-only: Lenis instance lives for the app lifetime

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}
